import React, {useEffect, useState} from "react"
import utils from "@mobiusjs/site-client/dist/helper/utils"
import metrics from "@mobiusjs/site-client/dist/helper/metrics"
import {useSelector} from "react-redux";

const Theme = ({}) => {
    const
        [update, setUpdate] = useState(null),
        [isLoading, setIsLoading] = useState(false),
        forceUpdate = () => setUpdate(Date.now())

    let view = 'Home',
        widget = useSelector(state => state.widgets.current),
        paymentFailed = useSelector(state => state.widgets.paymentFailed),
        paymentSuccess = useSelector(state => state.widgets.paymentSuccess),
        paymentSuccessInfo = useSelector(state => state.widgets.paymentSuccessInfo)

    if (widget) {
        if (widget.type === "deposit") view = "Deposit"
        if (widget.type === "tourBooking") view = "TourBooking"
        if (widget.type === "hotelBooking") view = "HotelBooking"
    }

    useEffect(() => {
        metrics.gtm(widget?.widget?.gtmId)
        metrics.pixel(widget?.widget?.pixelId)

        if (widget.type === "tourBooking") {
            if (!paymentFailed && !paymentSuccess) {
                metrics.addToCart({
                    items: [{
                        item_id: widget.tour.id,
                        item_name: widget.tour.title
                    }]
                })
            }
            if (paymentSuccess && paymentSuccessInfo) {
                if (!paymentSuccessInfo.firstSuccess) {
                    let summary = paymentSuccessInfo?.summary
                    let items = []
                    if (summary.adult) {
                        items.push({
                            item_id: paymentSuccessInfo.tour.id,
                            item_name: paymentSuccessInfo.tour.title + " [adult]",
                            price: parseFloat(summary.adultPrice),
                            quantity: parseInt(summary.adult)
                        })
                    }
                    if (summary.child) {
                        items.push({
                            item_id: paymentSuccessInfo.tour.id,
                            item_name: paymentSuccessInfo.tour.title + " [child]",
                            price: parseFloat(summary.childPrice),
                            quantity: parseInt(summary.child)
                        })
                    }
                    metrics.purchase({
                        currency: summary.currency.toUpperCase(),
                        value: parseFloat(summary.total),
                        items: items
                    })
                }
            }
        }
    }, []);

    try {
        let View = null,
            viewProps = {
                isLoading: isLoading,
                update: update,
                forceUpdate: forceUpdate
            }
        if (global.pluginViews && utils.inKeys(global.pluginViews, view)) View = global.pluginViews[view]
        return <View {...viewProps}/>
    } catch (e) {
        return null
    }
}

export default Theme
